import { Form, FormSpy } from "react-final-form";
import "./Pricing.scss";
import "./i18n";
import { PricingProps } from "./types";
import { useTranslation } from "react-i18next";
import useValidationSchema from "hooks/useValidationSchema";
import { validationSchema } from "./schemas";
import { Button } from "@pickit/pickit-components";
import { useMemo } from "react";
import arrayMutators from "final-form-arrays";
import ConfigForm from "./configForm/ConfigForm";
import TiersForm from "./tiersForm/TiersForm";
import AssuredForm from "./assuredForm/AssuredForm";
import { PricingType } from "reducers/types/regions";

const Pricing = (props: PricingProps): JSX.Element => {
  const { t } = useTranslation("polygonPricing");
  const { testId } = props;

  const disableForm = useMemo(
    () => !props.filters?.region || props.filters?.updated,
    [props]
  );

  return (
    <div>
      <Form
        onSubmit={(values) => props.onSubmit(values)}
        initialValues={props.initialValues}
        validate={useValidationSchema(validationSchema(props.isAssuredEnabled))}
        mutators={{
          ...arrayMutators,
          resetAssured: (_, state, { changeValue }) => {
            const aux = (state.formState.values as PricingType).assured;
            changeValue(state, "assured", () => props.cachedAssuredValues);
            props.setCachedAssuredValues(aux!!);
          },
        }}
      >
        {({ handleSubmit, form, dirty, invalid }) => (
          <form className="form-filter-transaction" onSubmit={handleSubmit}>
            <FormSpy
              subscription={{
                dirty: true,
                values: true,
                invalid: true,
              }}
              onChange={(form) => {
                props.setDirty(form.dirty);
              }}
            />
            <ConfigForm disableForm={disableForm} testId={`${testId}-config`} />
            <AssuredForm
              disableForm={disableForm}
              testId={`${testId}-assured`}
              isEnabled={props.isAssuredEnabled}
              setIsEnabled={props.setIsAssuredEnabled}
            />
            <TiersForm disableForm={disableForm} testId={`${testId}-tiers`} />
            <div className="container-polygon-general-buttons top-40">
              <div className="pricing-button-container">
                <Button
                  type="button"
                  label={t("global:restore")}
                  onClick={() => props.restore(dirty, form)}
                  disabled={!dirty || !!!props.filters.region?.id}
                  hierarchy="secondary"
                  testId={`${testId}-restore-button`}
                  width="220"
                />
              </div>
              <div className="pricing-button-container">
                <Button
                  type="submit"
                  disabled={!dirty || invalid}
                  label={t("global:saveChanges")}
                  hierarchy="primary"
                  testId={`${testId}-save-button`}
                  width="220"
                />
              </div>
            </div>
          </form>
        )}
      </Form>
    </div>
  );
};
export default Pricing;
